import _actions_get_legal from './_actions/get_legal.js'
import _actions_change from './_actions/change.js'
import _getters_data from './_getters/data.js'
import _mutations_set from './_mutations/set.js'
import _mutations_legals from './_mutations/legals.js'
import _mutations_data from './_mutations/data.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        data: _mutations_data,
        legals: _mutations_legals,
        set: _mutations_set,
    },
    getters:{
        data: _getters_data,
    },
    actions:{
        change: _actions_change,
        get_legal: _actions_get_legal,
    },
}